import { render, staticRenderFns } from "./ArticleComment.vue?vue&type=template&id=47d25741&scoped=true&"
import script from "./ArticleComment.vue?vue&type=script&lang=js&"
export * from "./ArticleComment.vue?vue&type=script&lang=js&"
import style0 from "./ArticleComment.vue?vue&type=style&index=0&id=47d25741&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d25741",
  null
  
)

export default component.exports